const BASE_URL = process.env.REACT_APP_API_URL;

//**************** F E T C H *****************/
const request = async (endpoint, { method = "GET", body, headers = {} } = {}) => {
    const isFormData = body instanceof FormData;

    const config = {
        method,
        credentials: "include",
        headers: {
            ...(isFormData ? {} : { "Content-Type": "application/json" }),
            ...headers,
        },
    };

    if (body) {
        config.body = isFormData ? body : JSON.stringify(body);
    }

    const response = await fetch(`${BASE_URL}${endpoint}`, config);

    let data;
    try {
        data = await response.json();
    } catch {
        data = null;
    }

    if (!response.ok) {
        throw new Error(data?.message || "API request error");
    }

    return data;
};

export const ApiFetch = {
    get: (endpoint) => request(endpoint),

    post: (endpoint, body) =>
        request(endpoint, {
            method: "POST",
            body,
        }),

    put: (endpoint, body) =>
        request(endpoint, {
            method: "PUT",
            body,
        }),

    delete: (endpoint) =>
        request(endpoint, {
            method: "DELETE",
        }),
};